<template>
  <div v-if="isLoading"></div>
  <div
    v-else-if="error"
    class="fallback-header ctpx-collection-promo-banner"
  ></div>
  <div v-else>
    <div v-if="sections.desktopBannerBackground"
      :style="{
        backgroundColor: sections.backgroundColor,
        backgroundImage: `url(${getBg()})`,
      }"
      id="collectionHeader"
      class="ctpx-collection-promo-banner ctpx-collection-intro-banner"
      v-bind:class="[
        sections.hideHeroSection == true ? 'hide-me' : 'show-me',
        classObject,
        colorToggle,
      ]"
      :class="[sections.mobileBannerBackground ? '' : 'no-mobile-banner']"
    >
    <div class="container-fluid">
      <div class="row flex-row-center">
        <!--------------layout center----------->
        <div
          v-if="sections.bannerLayout == 'center'"
          class="col-lg-10 offset-lg-1 text-center"
          v-bind:class="colorToggle"
        >
          <img
            v-if="sections.heroBannerLogo != null"
            :src="sections.heroBannerLogo.url"
            :style="{
              maxWidth: sections.logoWidth + 'px',
            }"
            class="img-responsive"
            :alt="sections.heroBannerLogo.filename"
          />

          <h1 class="d1">{{ sections.bannerTitle }}</h1>
          <div
            v-if="sections.bodyText"
            class="intro-content"
            v-html="sections.bodyText"
          ></div>
          <div class="row" style="justify-content: center">
            <div class="col-auto">
              <a
                v-if="sections.ctaLink"
                :href="sections.ctaLink"
                class="btn"
                :class="
                  sections.ctaLightMode == true ? 'btn-white' : 'btn-black'
                "
              >
                {{ sections.ctaTitle }}
              </a>
              <a
                v-if="sections.ctaLink2"
                :href="sections.ctaLink2"
                class="btn"
                :class="
                  sections.ctaLightMode2 == true ? 'btn-white' : 'btn-black'
                "
                >{{ sections.ctaTitle2 }}
              </a>
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!--------------layout panel------------>
        <div
          v-if="sections.bannerLayout == 'panel'"
          class="header-bg"
          :style="{
            backgroundImage:
              'url(' + sections.desktopBannerBackground.url + ')',
          }"
        ></div>
        <!--.header-bg-->
        <div
          v-if="sections.bannerLayout == 'panel'"
          class="header-panel col-md-5 offset-md-7"
        >
          <div class="hp-inner">
            <h1 class="d1">{{ sections.bannerTitle }}</h1>
            <h6 v-if="sections.bannerSubtitle">
              {{ sections.bannerSubtitle }}
            </h6>
            <div
              class="intro-content"
              v-if="sections.bodyText"
              v-html="sections.bodyText"
            ></div>

            <div class="row icon-row justify-content-center">
              <div v-for="(p, index) in panelIcon2" class="col-4">
                <span v-bind:class="sections.panelIcons[index]">
                  <span class="img-icon"></span>
                  {{ p }}</span
                >
              </div>
              <!-- .col-4 -->
            </div>
            <!--.icon-row-->
          </div>
          <!--.hp-inner-->
        </div>
        <!--.header-panel-->

        <!-----------layout left------------->
        <div
          v-if="
            sections.bannerLayout == 'left' || sections.bannerLayout == 'right'
          "
          class="col-lg-8"
          v-bind:class="(colorToggle, getClass())"
          :class="[sections.mobileBannerBackground ? '' : 'px-0 px-md-3']"
        >
          <img
            v-if="sections.heroBannerLogo != null"
            :src="sections.heroBannerLogo.url"
            :style="{
              maxWidth: sections.logoWidth + 'px',
            }"
            class="img-responsive"
            :alt="sections.heroBannerLogo.filename"
          />

          <h1 class="d1">{{ sections.bannerTitle }}</h1>
          <div
            v-if="sections.bodyText"
            class="intro-content"
            v-html="sections.bodyText"
          ></div>

          <div class="row btn-row">
            <div class="col-auto">
              <a
                v-if="sections.ctaLink"
                :href="sections.ctaLink"
                class="btn"
                :class="
                  sections.ctaLightMode == true ? 'btn-white' : 'btn-black'
                "
              >
                {{ sections.ctaTitle }}
              </a>
              <a
                v-if="sections.ctaLink2"
                :href="sections.ctaLink2"
                class="btn"
                :class="
                  sections.ctaLightMode2 == true ? 'btn-white' : 'btn-black'
                "
                >{{ sections.ctaTitle2 }}
              </a>
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!-- .col-lg-7 -->
      </div>
      <!-- .row -->
    </div>
    <!-- .container-fluid -->
  </div>
  <!-- ========== No Background Image ========== -->
  <div v-else 
      id="collectionHeader"
      class="ctpx-collection-basic-banner"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="col-12" id="plpBreadcrumbs">
          <!-- breadcrumbs -->
        </div><!-- .col -->
      </div><!-- .row -->
      <div class="row">
        <div class="col">
          <h1 class="d1">{{ sections.bannerTitle }}</h1>
        </div><!-- .col -->
      </div><!-- .row -->
    </div><!-- .container-fluid -->
  </div>
</div>
</template>

<script src="./ctrl-collection-header.js"></script>
